angular.module 'zc.projects'

.controller 'SegmentListCtrl', ($scope, $state, $translate, Page, currentProject) ->
  Page.setBodyClass ''
  $translate('projectsSegments.controllers.list.segumento_ichiran').then (translation) ->
    Page.setTitle translation


  $scope.currentProject = currentProject



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.segments/list.controller.coffee